import React from "react";
import { GOOGLE_OPTIMIZE_KEY } from "config/analytics";
import { SITE_KEY } from "config/reCaptcha";
import { GoogleReCaptchaProvider } from "react-google-recaptcha-v3";
import Head from "next/head";

import Container from "./Container";
import Form from "./form";

export default function Register() {
  return (
    <Container>
      {GOOGLE_OPTIMIZE_KEY && (
        <Head>
          <script
            async
            src={`https://www.googleoptimize.com/optimize.js?id=${GOOGLE_OPTIMIZE_KEY}`}
          />
        </Head>
      )}
      <GoogleReCaptchaProvider reCaptchaKey={SITE_KEY}>
        <Form />
      </GoogleReCaptchaProvider>
    </Container>
  );
}
